import { Extension, getHTMLFromFragment } from '@tiptap/core'

import { Hotkeys } from '#src/constants/hotkeys.ts'
import { useTaskComposerStore } from '#src/hooks/useTaskComposerStore.ts'

export const CreateTaskShortcutExtension = Extension.create({
  name: 'createTaskShortcut',

  addKeyboardShortcuts() {
    return {
      [Hotkeys.TiptapNewTaskFromText]: () => {
        const { from, to } = this.editor.state.selection
        const slice = this.editor.state.doc.slice(from, to)
        const selectedHtml = getHTMLFromFragment(
          slice.content,
          this.editor.schema
        )

        const editor = this.editor
        const store = useTaskComposerStore.getState()

        // Focus editor when dialog closes (regardless of task creation)
        store.setOnClose(() => {
          editor.chain().focus().run()
        })

        if (!selectedHtml.trim()) {
          // No text selected - insert task mention at cursor position
          store.setOnTaskCreated((task) => {
            editor
              .chain()
              .focus()
              .insertContentAt(from, {
                type: 'mention',
                attrs: {
                  reference: task.reference.reference,
                },
              })
              .run()
          })
          store.setOpen(true)
          return true
        }

        store.setOnTaskCreated((task) => {
          editor
            .chain()
            .focus()
            .deleteRange({ from, to })
            .insertContentAt(from, {
              type: 'mention',
              attrs: {
                reference: task.reference.reference,
              },
            })
            .run()
        })

        store.setDefaultValues({
          title: selectedHtml,
        })
        store.setOpen(true)

        return true
      },
    }
  },
})
